import {
    IncludedExtras,
    IncludedExtrasProps,
} from "features/vehicleDetails/components/VehicleDetails/components/IncludedExtras";

import Wrapper from "../common/Wrapper";

const IncludedExtrasModal = (props: IncludedExtrasProps) => {
    return (
        <Wrapper>
            <IncludedExtras {...props} isInsideModal />
        </Wrapper>
    );
};

export default IncludedExtrasModal;
